import { useEffect, useState } from 'react';
import { Button, DatePickerWithRange, Div } from '@gaiads/telia-react-component-library';
import { useTranslation } from 'react-i18next';

interface ReportDatePickerProps {
  buttonText: string;
  dateRangeLabel: string;
  handleButtonClick: (date: [Date, Date]) => void;
  loading: boolean;
}

export default function ReportWithDatePicker({ buttonText, dateRangeLabel, handleButtonClick, loading }: Readonly<ReportDatePickerProps>) {
  const { t } = useTranslation('backOffice');

  const [date, setDate] = useState<[Date | undefined, Date | undefined]>();
  const [dateError, setDateError] = useState(false);

  useEffect(() => {
    if (date?.[0] && date[1] && date[0] >= date[1]) {
      setDateError(true);
    } else {
      setDateError(false);
    }
  }, [date]);

  const isButtonDisabled = loading || dateError || !date?.[0] || !date[1];

  return (
    <>
      <Div style={{ height: '130px' }}>
        <DatePickerWithRange
          label={dateRangeLabel}
          errorText={dateError ? t('reportsPage.dateErrorMessage') : undefined}
          fromDatePicker={{
            onChange: date => {
              date.setUTCHours(0);
              setDate(prev => [date, prev?.[1] ?? undefined]);
            },
            format: 'DD.MM.YYYY',
            placeholderFormat: 'DD.MM.YYYY',
            locale: 'en',
          }}
          toDatePicker={{
            onChange: date => {
              date.setUTCHours(23, 59, 59, 999);
              setDate(prev => [prev?.[0] ?? undefined, date]);
            },
            format: 'DD.MM.YYYY',
            placeholderFormat: 'DD.MM.YYYY',
            locale: 'en',
          }}
          data-testid="report-date-picker"
        />
      </Div>
      <Button
        block
        variant="primary"
        onClick={() => {
          if (date?.[0] && date[1]) {
            handleButtonClick([date[0], date[1]]);
          }
        }}
        disabled={isButtonDisabled}
      >
        {buttonText}
      </Button>
    </>
  );
}
